import { Group } from 'three';

import { removeSelectionGroups, SELECTION_GROUP_TYPES } from './selection-label.helper';
import { ToolResult } from '../../types/tool.types';
import { ToolContext } from '../tool-context.type';

export const clearSelections = async (
	_args: unknown,
	context: ToolContext
): Promise<ToolResult> => {
	const { threeInstance, publish } = context;
	if (!threeInstance) {
		return { success: false, error: 'Three.js instance not initialized' };
	}

	const islands = threeInstance.getIslands();
	if (!islands || islands.length === 0) {
		return { success: true, data: { cleared: false, reason: 'No islands in scene' } };
	}

	const objectHolder = islands[0].parent as Group;
	if (!objectHolder) {
		return { success: true, data: { cleared: false, reason: 'Could not access scene' } };
	}

	// Remove all selection label groups
	removeSelectionGroups(objectHolder, [...SELECTION_GROUP_TYPES]);

	publish('selections', 'cleared', {
		ref: 'selections',
		old: null,
		new: null
	});

	return { success: true, data: { cleared: true } };
};
